import type { LabelMainInfo } from '@/components/shared/types'
import type Label from '@/data/models/domain/Label'
import type { LabelColorValue, LabelValue } from '@/services/domain/label/types'

export enum AddLabelFormFields {
  label = 'label',
  color = 'color',
}

export interface AddLabelFormScheme {
  [AddLabelFormFields.label]: LabelValue
  [AddLabelFormFields.color]: LabelColorValue
}

export type AddLabelFormServiceSubmitConfig = {
  addLabelHandler: (labelInfo: LabelMainInfo) => Promise<void>
}

export interface AddLabelFormServiceBuildingParams {
  initialLabelName: string | null
  initialLabelStyle: Pick<Label, 'color' | 'style'> | null
}
